import React, { useEffect, useState } from "react";
import styles from "./WalletContainer.module.scss";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import Button from "../../ui/Button/Button";
import { CoinsIcon } from "../../assets/icons/CoinsIcon";
import { ChevronRightIcon } from "../../assets/icons/ChevronRightIcon";
import { TimerIcon } from "../../assets/icons/TimerIcon";
import { ModalChooseTariff } from "../ModalChooseTariff/ModalChooseTariff";
import { ModalInputPrice } from "../ModalInputPrice/ModalInputPrice";
import Switcher from "../../ui/Switcher/Switcher";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatDateString } from "../../utils/methods/validateDateTariff";
import { RefreshIcon } from "../../assets/icons/RefreshIcon";
import {
  getBilling,
  getTariffs,
  tariffAutoRenewal,
} from "../../utils/api/actions/billing";
import { BeatLoader } from "react-spinners";
import { formatNumberWithSpaces } from "../../utils/methods/numberFormatter";

const HistoryItem = ({ date, sum, type, description }) => {
  return (
    <div className={styles.itemContainer}>
      <div className={styles.date}>{formatDateString(date, true)}</div>
      <div className={`${styles.sum} ${type === "income" ? styles.inc : ""}`}>
        {sum !== 0 && (type === "income" ? "+" : "-")} {sum !== 0 && `${sum} ₽`}
      </div>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export const WalletContainer = () => {
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const pay = searchParams.get("pay");

  const tariffs = useSelector((state) => state?.billing?.tariffs);
  const billing = useSelector((state) => state?.billing?.data);
  const user = useSelector((state) => state?.user?.data);

  const tariff = billing?.tariff || user?.billing?.tariffId;
  const history = billing?.history;
  const tariffEndDate = billing?.tariffEndDate || user?.billing?.tariffEndDate;
  const endDateTariff = formatDateString(tariffEndDate, true);

  useEffect(() => {
    dispatch(getTariffs());
    dispatch(getBilling(user.id, setLoading));
  }, [dispatch, user.id]);

  const [visibleModalChooseTariff, setVisibleModalChooseTariff] =
    useState(false);
  const [visibleModalInputPrice, setVisibleModalInputPrice] = useState(false);
  const [autoPayment, setAutoPayment] = useState(
    billing?.tariffAutoRenewal || false
  );
  const [loading, setLoading] = useState(false);

  const balance = billing?.ballance || user?.billing?.ballance;
  const tariffName =
    tariffs?.find(
      (tariffItem) => tariffItem.id === (tariff?.id ? tariff.id : tariff)
    )?.name || "Тариф не найден";

  const sortedHistory = history?.slice().sort((a, b) => {
    const [dateA, timeA] = a.date.split(" "); // разделяем дату и время
    const [dateB, timeB] = b.date.split(" "); // разделяем дату и время

    const [dayA, monthA, yearA] = dateA.split("-"); // разбиваем на день, месяц, год
    const [dayB, monthB, yearB] = dateB.split("-"); // разбиваем на день, месяц, год

    const fullDateA = new Date(yearA, monthA - 1, dayA, ...timeA.split(":"));
    const fullDateB = new Date(yearB, monthB - 1, dayB, ...timeB.split(":"));

    return fullDateA - fullDateB; // сортируем от более свежих к старым
  });

  useEffect(() => {
    if (pay) {
      setVisibleModalChooseTariff(true);
    }
  }, [pay]);

  const handleOpenModalChooseTariff = () => {
    setVisibleModalChooseTariff(true);
  };

  const handleCloseModalChooseTariff = () => {
    setVisibleModalChooseTariff(false);
  };

  const handleOpenModalInputPrice = () => {
    setVisibleModalInputPrice(true);
  };

  const handleCloseModalInputPrice = () => {
    setVisibleModalInputPrice(false);
  };

  const handleToggle = () => {
    const newStatus = !autoPayment;
    setAutoPayment(newStatus);

    if (user?.id) {
      const data = {
        userId: user.id,
        tariffAutoRenewal: newStatus,
      };
      dispatch(tariffAutoRenewal(data));
    }
  };

  return (
    <div className={styles.body}>
      <ScreenHeader title={"Кошелёк"} />
      <div className={styles.content}>
        <div className={styles.userWalletInfo}>
          <div className={styles.fundsContainer}>
            <div className={styles.title}>Остаток средств:</div>
            <div className={styles.ballanceContainer}>
              <div className={styles.funds}>
                {loading ? <BeatLoader /> : formatNumberWithSpaces(balance)}{" "}
                {loading ? "" : "₽"}
              </div>

              <div
                className={styles.refresh}
                onClick={() => {
                  // window.location.reload();
                  dispatch(getBilling(user.id, setLoading));
                }}
              >
                <RefreshIcon size={20} fill={"black"} />
              </div>
            </div>

            <Button
              leftIcon={<CoinsIcon size={17} fill={"white"} />}
              title={"Пополнить"}
              className={styles.fundsButton}
              titleClassName={styles.titleButton}
              onClick={handleOpenModalInputPrice}
            />
          </div>
        </div>
        <div className={styles.container}>
          <div className={styles.tariffContainer}>
            <div className={styles.title}>Текущий тарифный план:</div>
            <div
              className={styles.tariffValueContainer}
              onClick={handleOpenModalChooseTariff}
            >
              <div className={styles.value}>
                {loading ? (
                  <BeatLoader />
                ) : (
                  <>
                    {tariffName}{" "}
                    {endDateTariff && <span>до {endDateTariff}</span>}
                  </>
                )}
              </div>
              {!loading && (
                <ChevronRightIcon width={13} height={20} fill={"black"} />
              )}
            </div>
          </div>
          <div>
            <Switcher
              labelOn={"Автоплатёж"}
              labelOff={"Подключить автоплатёж"}
              bool={autoPayment}
              onToggle={handleToggle}
            />
          </div>
        </div>
      </div>

      <div className={styles.historyContainer}>
        <div className={styles.title}>
          <TimerIcon size={25} fill={"#C7CDDD"} />
          <div>История операций:</div>
        </div>
        <div className={styles.historyItems}>
          {sortedHistory ? (
            sortedHistory
              ?.slice()
              .reverse()
              .map((item, index) => {
                return (
                  <HistoryItem
                    key={item.id}
                    date={item.date}
                    sum={item.sum}
                    type={item.type}
                    description={item.description}
                  />
                );
              })
          ) : (
            <div className={styles.noHistoryMessage}>
              Здесь будет отображаться история ваших операций по счету, но пока
              она пуста.
            </div>
          )}
        </div>
      </div>
      <ModalChooseTariff
        visible={visibleModalChooseTariff}
        handleClose={handleCloseModalChooseTariff}
      />
      <ModalInputPrice
        visible={visibleModalInputPrice}
        handleClose={handleCloseModalInputPrice}
      />
    </div>
  );
};
